import { ApartmentStatus } from '../../types/config';

export const inventoryDataHavatzelet = [
  {
    building: '1',
    number: 1,
    type: 'C1',
    floor: 1,
    rooms: 3,
    area: 104,
    balconyArea: 263,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_C1_select_floor1',
    nrId: 1,
    tourUrl: 'https://my.treedis.com/tour/c1',
    galleryType: 'galleryC1',
    galleryCount: 15,
    hasVideo: true,
    floorPlanImage: 'floorplanC1',
  },
  {
    building: '1',
    number: 2,
    type: 'C2',
    floor: 1,
    rooms: 3,
    area: 86,
    balconyArea: 105,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_C2_select_floor1',
    nrId: 2,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanC2',
  },
  {
    building: '1',
    number: 7,
    type: 'B1',
    floor: 2,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor2',
    nrId: 3,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '1',
    number: 11,
    type: 'B1',
    floor: 3,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor3',
    nrId: 4,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '1',
    number: 15,
    type: 'B1',
    floor: 4,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor4',
    nrId: 5,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '1',
    number: 19,
    type: 'B1',
    floor: 5,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor5',
    nrId: 6,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '1',
    number: 23,
    type: 'B1',
    floor: 6,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor6',
    nrId: 7,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '1',
    number: 27,
    type: 'B1',
    floor: 7,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_B1_select_floor7',
    nrId: 8,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '1',
    number: 31,
    type: 'A1',
    floor: 8,
    rooms: 5,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A1_select_floor8',
    nrId: 9,
    tourUrl: 'https://my.treedis.com/tour/a1-5-apartment',
    galleryType: 'galleryA1',
    galleryCount: 22,
    hasVideo: true,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: '1',
    number: 35,
    type: 'A1',
    floor: 9,
    rooms: 5,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_A1_select_floor9',
    nrId: 10,
    tourUrl: 'https://my.treedis.com/tour/a1-5-apartment',
    galleryType: 'galleryA1',
    galleryCount: 22,
    hasVideo: true,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: '1',
    number: 43,
    type: 'D',
    floor: 11,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_D_select_floor11',
    nrId: 11,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '1',
    number: 55,
    type: 'D',
    floor: 14,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_D_select_floor14',
    nrId: 12,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '1',
    number: 56,
    type: 'D1',
    floor: 15,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_D1_select_floor15',
    nrId: 13,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanD1',
  },
  {
    building: '1',
    number: 58,
    type: 'D',
    floor: 15,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_D_select_floor15',
    nrId: 14,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '1',
    number: 59,
    type: 'D1',
    floor: 16,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_D1_select_floor16',
    nrId: 15,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanD1',
  },
  {
    building: '1',
    number: 60,
    type: 'D2',
    floor: 16,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_D2_select_floor16',
    nrId: 16,
    tourUrl: 'https://my.treedis.com/tour/d2',
    galleryType: 'galleryD2',
    hasVideo: true,
    galleryCount: 20,
    floorPlanImage: 'floorplanD2',
  },
  {
    building: '1',
    number: 64,
    type: 'F',
    floor: 18,
    rooms: 6,
    area: 250,
    balconyArea: 179,
    status: ApartmentStatus.Available,
    liked: false,
    id: '1_F_select_floor18',
    nrId: 17,
    tourUrl: 'https://my.treedis.com/tour/f2',
    galleryType: 'galleryF',
    galleryCount: 38,
    hasVideo: true,
    floorPlanImage: 'floorplanF',
  },
  {
    building: '2',
    number: 1,
    type: 'C3-T',
    floor: 1,
    rooms: 3,
    area: 104,
    balconyArea: 235,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C3_select_floor1',
    nrId: 18,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanC3',
  },
  {
    building: '2',
    number: 2,
    type: 'C2-T',
    floor: 1,
    rooms: 3,
    area: 86,
    balconyArea: 105,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C2_select_floor1',
    nrId: 19,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanC2',
  },
  {
    building: '2',
    number: 3,
    type: 'C1-T',
    floor: 1,
    rooms: 3,
    area: 104,
    balconyArea: 335,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C1_select_floor1',
    nrId: 20,
    tourUrl: 'https://my.treedis.com/tour/c1',
    galleryType: 'galleryC1',
    galleryCount: 15,
    hasVideo: true,
    floorPlanImage: 'floorplanC1',
  },
  {
    building: '2',
    number: 7,
    type: 'B1-T',
    floor: 2,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_B1_select_floor2',
    nrId: 21,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '2',
    number: 11,
    type: 'B1-T',
    floor: 3,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_B1_select_floor3',
    nrId: 22,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '2',
    number: 15,
    type: 'B1-T',
    floor: 4,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_B1_select_floor4',
    nrId: 23,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanA',
  },
  {
    building: '2',
    number: 19,
    type: 'B1-T',
    floor: 5,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_B1_select_floor5',
    nrId: 24,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '2',
    number: 23,
    type: 'B1-T',
    floor: 6,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_B1_select_floor6',
    nrId: 25,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '2',
    number: 27,
    type: 'B1-T',
    floor: 7,
    rooms: 4,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_B1_select_floor7',
    nrId: 26,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanB1',
  },
  {
    building: '2',
    number: 31,
    type: 'A1-T',
    floor: 8,
    rooms: 5,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_A1_select_floor8',
    nrId: 27,
    tourUrl: 'https://my.treedis.com/tour/a1-5-apartment',
    galleryType: 'galleryF',
    galleryCount: 38,
    hasVideo: true,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: '2',
    number: 35,
    type: 'A1-T',
    floor: 9,
    rooms: 5,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_A1_select_floor9',
    nrId: 28,
    tourUrl: 'https://my.treedis.com/tour/a1-5-apartment',
    galleryType: 'galleryA1',
    galleryCount: 22,
    hasVideo: true,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: '2',
    number: 39,
    type: 'A1-T',
    floor: 10,
    rooms: 5,
    area: 141,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_A1_select_floor10',
    nrId: 29,
    tourUrl: 'https://my.treedis.com/tour/a1-5-apartment',
    galleryType: 'galleryA1',
    galleryCount: 22,
    hasVideo: true,
    floorPlanImage: 'floorplanA1',
  },
  {
    building: '2',
    number: 43,
    type: 'D-T',
    floor: 11,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D_select_floor11',
    nrId: 30,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '2',
    number: 47,
    type: 'D-T',
    floor: 12,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D_select_floor12',
    nrId: 31,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '2',
    number: 51,
    type: 'D-T',
    floor: 13,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D_select_floor13',
    nrId: 32,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '2',
    number: 53,
    type: 'C-T',
    floor: 14,
    rooms: 3,
    area: 86,
    balconyArea: 10,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_C_select_floor14',
    nrId: 33,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanC',
  },
  {
    building: '2',
    number: 55,
    type: 'D-T',
    floor: 14,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D_select_floor14',
    nrId: 34,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '2',
    number: 56,
    type: 'D2',
    floor: 15,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D2_select_floor15',
    nrId: 35,
    tourUrl: 'https://my.treedis.com/tour/d2',
    galleryType: 'galleryD2',
    hasVideo: true,
    galleryCount: 20,
    floorPlanImage: 'floorplanD2',
  },
  {
    building: '2',
    number: 57,
    type: 'D1',
    floor: 15,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D1_select_floor15',
    nrId: 36,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanD1',
  },
  {
    building: '2',
    number: 58,
    type: 'D-T',
    floor: 15,
    rooms: 5,
    area: 165,
    balconyArea: 30,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D_select_floor15',
    nrId: 37,
    tourUrl: 'https://my.treedis.com/tour/d-3c14f15a',
    galleryType: 'galleryD',
    hasVideo: true,
    galleryCount: 21,
    floorPlanImage: 'floorplanD',
  },
  {
    building: '2',
    number: 59,
    type: 'D2',
    floor: 16,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D2_select_floor16',
    nrId: 38,
    tourUrl: 'https://my.treedis.com/tour/d2',
    galleryType: 'galleryD2',
    hasVideo: true,
    galleryCount: 20,
    floorPlanImage: 'floorplanD2',
  },
  {
    building: '2',
    number: 60,
    type: 'D1',
    floor: 16,
    rooms: 5,
    area: 153,
    balconyArea: 25,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_D1_select_floor16',
    nrId: 39,
    galleryType: 'gallerytype',
    galleryCount: 4,
    floorPlanImage: 'floorplanD1',
  },
  {
    building: '2',
    number: 63,
    type: 'E',
    floor: 17,
    rooms: 5,
    area: 198,
    balconyArea: 81,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_E_select_floor17',
    nrId: 40,
    galleryType: 'gallerytype',
    galleryCount: 8,
    floorPlanImage: 'floorplanE',
  },
  {
    building: '2',
    number: 64,
    type: 'F',
    floor: 18,
    rooms: 6,
    area: 250,
    balconyArea: 179,
    status: ApartmentStatus.Available,
    liked: false,
    id: '2_F_select_floor18',
    nrId: 41,
    tourUrl: 'https://my.treedis.com/tour/f2',
    galleryType: 'galleryF',
    galleryCount: 38,
    hasVideo: true,
    floorPlanImage: 'floorplanF',
  },
];
